import * as axios from 'axios'
import { location } from '@/infrastructure/Configuration'
import BlogService from '@/services/BlogService'

axios.defaults.headers.common['Accept-Language'] = location
axios.defaults.timeout = 30000

export const blogService = new BlogService(axios)
